// Guardian AI User Service Protocol Definitions
// User management, profiles, certifications, AI agents, and subscriptions
//
// Version: v1
// Source: Merged from backend user_services.proto + frontend user.proto

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/user/user.proto (package guardianai.v1.user, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/user/user.proto.
 */
export const file_guardianai_v1_user_user: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.user.UserIdRequest
 */
export type UserIdRequest = Message<"guardianai.v1.user.UserIdRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.user.UserIdRequest
 */
export type UserIdRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.user.UserIdRequest.
 * Use `create(UserIdRequestSchema)` to create a new message.
 */
export const UserIdRequestSchema: GenMessage<UserIdRequest, {jsonType: UserIdRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 0);

/**
 * @generated from message guardianai.v1.user.UserProfile
 */
export type UserProfile = Message<"guardianai.v1.user.UserProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName: string;

  /**
   * USER, INVESTIGATOR, MEDIATOR, EVIDENCE_SCOUT, AI_AGENT_EVIDENCE_SCOUT, AI_AGENT_INVESTIGATOR, ADMIN, BUSINESS_CONTENT_CREATOR
   *
   * @generated from field: string role = 5;
   */
  role: string;

  /**
   * ACTIVE, RESTRICTED, INACTIVE
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;

  /**
   * ISO 3166-1 alpha-2 country code
   *
   * @generated from field: string country = 9;
   */
  country: string;

  /**
   * State/Province/Region code
   *
   * @generated from field: string state_province = 10;
   */
  stateProvince: string;

  /**
   * @generated from field: guardianai.v1.user.CertificationStatus certification_status = 11;
   */
  certificationStatus?: CertificationStatus;
};

/**
 * @generated from message guardianai.v1.user.UserProfile
 */
export type UserProfileJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string username = 2;
   */
  username?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName?: string;

  /**
   * USER, INVESTIGATOR, MEDIATOR, EVIDENCE_SCOUT, AI_AGENT_EVIDENCE_SCOUT, AI_AGENT_INVESTIGATOR, ADMIN, BUSINESS_CONTENT_CREATOR
   *
   * @generated from field: string role = 5;
   */
  role?: string;

  /**
   * ACTIVE, RESTRICTED, INACTIVE
   *
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt?: string;

  /**
   * ISO 3166-1 alpha-2 country code
   *
   * @generated from field: string country = 9;
   */
  country?: string;

  /**
   * State/Province/Region code
   *
   * @generated from field: string state_province = 10;
   */
  stateProvince?: string;

  /**
   * @generated from field: guardianai.v1.user.CertificationStatus certification_status = 11;
   */
  certificationStatus?: CertificationStatusJson;
};

/**
 * Describes the message guardianai.v1.user.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile, {jsonType: UserProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 1);

/**
 * @generated from message guardianai.v1.user.CertificationStatus
 */
export type CertificationStatus = Message<"guardianai.v1.user.CertificationStatus"> & {
  /**
   * @generated from field: bool is_certified = 1;
   */
  isCertified: boolean;

  /**
   * @generated from field: repeated guardianai.v1.user.Certification certifications = 2;
   */
  certifications: Certification[];

  /**
   * @generated from field: bool can_bid_marketplace = 3;
   */
  canBidMarketplace: boolean;

  /**
   * PENDING, VERIFIED, REJECTED, NOT_REQUIRED
   *
   * @generated from field: string verification_status = 4;
   */
  verificationStatus: string;

  /**
   * @generated from field: string last_verification_date = 5;
   */
  lastVerificationDate: string;

  /**
   * @generated from field: repeated string required_certifications = 6;
   */
  requiredCertifications: string[];

  /**
   * @generated from field: repeated string eligible_regions = 7;
   */
  eligibleRegions: string[];

  /**
   * @generated from field: repeated string restricted_regions = 8;
   */
  restrictedRegions: string[];
};

/**
 * @generated from message guardianai.v1.user.CertificationStatus
 */
export type CertificationStatusJson = {
  /**
   * @generated from field: bool is_certified = 1;
   */
  isCertified?: boolean;

  /**
   * @generated from field: repeated guardianai.v1.user.Certification certifications = 2;
   */
  certifications?: CertificationJson[];

  /**
   * @generated from field: bool can_bid_marketplace = 3;
   */
  canBidMarketplace?: boolean;

  /**
   * PENDING, VERIFIED, REJECTED, NOT_REQUIRED
   *
   * @generated from field: string verification_status = 4;
   */
  verificationStatus?: string;

  /**
   * @generated from field: string last_verification_date = 5;
   */
  lastVerificationDate?: string;

  /**
   * @generated from field: repeated string required_certifications = 6;
   */
  requiredCertifications?: string[];

  /**
   * @generated from field: repeated string eligible_regions = 7;
   */
  eligibleRegions?: string[];

  /**
   * @generated from field: repeated string restricted_regions = 8;
   */
  restrictedRegions?: string[];
};

/**
 * Describes the message guardianai.v1.user.CertificationStatus.
 * Use `create(CertificationStatusSchema)` to create a new message.
 */
export const CertificationStatusSchema: GenMessage<CertificationStatus, {jsonType: CertificationStatusJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 2);

/**
 * @generated from message guardianai.v1.user.Certification
 */
export type Certification = Message<"guardianai.v1.user.Certification"> & {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId: string;

  /**
   * PI_LICENSE, DIGITAL_FORENSICS, FRAUD_INVESTIGATION
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string issuing_authority = 3;
   */
  issuingAuthority: string;

  /**
   * @generated from field: string certificate_number = 4;
   */
  certificateNumber: string;

  /**
   * @generated from field: string issued_date = 5;
   */
  issuedDate: string;

  /**
   * @generated from field: string expiry_date = 6;
   */
  expiryDate: string;

  /**
   * ACTIVE, EXPIRED, SUSPENDED, REVOKED
   *
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * PENDING, VERIFIED, REJECTED
   *
   * @generated from field: string verification_status = 8;
   */
  verificationStatus: string;

  /**
   * @generated from field: string document_url = 9;
   */
  documentUrl: string;

  /**
   * @generated from field: string country = 10;
   */
  country: string;

  /**
   * @generated from field: string state_province = 11;
   */
  stateProvince: string;

  /**
   * @generated from field: repeated string valid_regions = 12;
   */
  validRegions: string[];
};

/**
 * @generated from message guardianai.v1.user.Certification
 */
export type CertificationJson = {
  /**
   * @generated from field: string certification_id = 1;
   */
  certificationId?: string;

  /**
   * PI_LICENSE, DIGITAL_FORENSICS, FRAUD_INVESTIGATION
   *
   * @generated from field: string type = 2;
   */
  type?: string;

  /**
   * @generated from field: string issuing_authority = 3;
   */
  issuingAuthority?: string;

  /**
   * @generated from field: string certificate_number = 4;
   */
  certificateNumber?: string;

  /**
   * @generated from field: string issued_date = 5;
   */
  issuedDate?: string;

  /**
   * @generated from field: string expiry_date = 6;
   */
  expiryDate?: string;

  /**
   * ACTIVE, EXPIRED, SUSPENDED, REVOKED
   *
   * @generated from field: string status = 7;
   */
  status?: string;

  /**
   * PENDING, VERIFIED, REJECTED
   *
   * @generated from field: string verification_status = 8;
   */
  verificationStatus?: string;

  /**
   * @generated from field: string document_url = 9;
   */
  documentUrl?: string;

  /**
   * @generated from field: string country = 10;
   */
  country?: string;

  /**
   * @generated from field: string state_province = 11;
   */
  stateProvince?: string;

  /**
   * @generated from field: repeated string valid_regions = 12;
   */
  validRegions?: string[];
};

/**
 * Describes the message guardianai.v1.user.Certification.
 * Use `create(CertificationSchema)` to create a new message.
 */
export const CertificationSchema: GenMessage<Certification, {jsonType: CertificationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 3);

/**
 * @generated from message guardianai.v1.user.UpdateUserProfileRequest
 */
export type UpdateUserProfileRequest = Message<"guardianai.v1.user.UpdateUserProfileRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName: string;
};

/**
 * @generated from message guardianai.v1.user.UpdateUserProfileRequest
 */
export type UpdateUserProfileRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName?: string;
};

/**
 * Describes the message guardianai.v1.user.UpdateUserProfileRequest.
 * Use `create(UpdateUserProfileRequestSchema)` to create a new message.
 */
export const UpdateUserProfileRequestSchema: GenMessage<UpdateUserProfileRequest, {jsonType: UpdateUserProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 4);

/**
 * @generated from message guardianai.v1.user.UserList
 */
export type UserList = Message<"guardianai.v1.user.UserList"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.UserProfile users = 1;
   */
  users: UserProfile[];
};

/**
 * @generated from message guardianai.v1.user.UserList
 */
export type UserListJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.UserProfile users = 1;
   */
  users?: UserProfileJson[];
};

/**
 * Describes the message guardianai.v1.user.UserList.
 * Use `create(UserListSchema)` to create a new message.
 */
export const UserListSchema: GenMessage<UserList, {jsonType: UserListJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 5);

/**
 * @generated from message guardianai.v1.user.ListUsersRequest
 */
export type ListUsersRequest = Message<"guardianai.v1.user.ListUsersRequest"> & {
  /**
   * @generated from field: string filter = 1;
   */
  filter: string;
};

/**
 * @generated from message guardianai.v1.user.ListUsersRequest
 */
export type ListUsersRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;
};

/**
 * Describes the message guardianai.v1.user.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest, {jsonType: ListUsersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 6);

/**
 * @generated from message guardianai.v1.user.UserRestrictionRequest
 */
export type UserRestrictionRequest = Message<"guardianai.v1.user.UserRestrictionRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: bool restrict = 3;
   */
  restrict: boolean;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.user.UserRestrictionRequest
 */
export type UserRestrictionRequestJson = {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: bool restrict = 3;
   */
  restrict?: boolean;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.user.UserRestrictionRequest.
 * Use `create(UserRestrictionRequestSchema)` to create a new message.
 */
export const UserRestrictionRequestSchema: GenMessage<UserRestrictionRequest, {jsonType: UserRestrictionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 7);

/**
 * @generated from message guardianai.v1.user.UserRestrictionResponse
 */
export type UserRestrictionResponse = Message<"guardianai.v1.user.UserRestrictionResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.user.UserRestrictionResponse
 */
export type UserRestrictionResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.user.UserRestrictionResponse.
 * Use `create(UserRestrictionResponseSchema)` to create a new message.
 */
export const UserRestrictionResponseSchema: GenMessage<UserRestrictionResponse, {jsonType: UserRestrictionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 8);

/**
 * @generated from message guardianai.v1.user.RestrictionsResponse
 */
export type RestrictionsResponse = Message<"guardianai.v1.user.RestrictionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.UserRestriction restrictions = 1;
   */
  restrictions: UserRestriction[];
};

/**
 * @generated from message guardianai.v1.user.RestrictionsResponse
 */
export type RestrictionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.UserRestriction restrictions = 1;
   */
  restrictions?: UserRestrictionJson[];
};

/**
 * Describes the message guardianai.v1.user.RestrictionsResponse.
 * Use `create(RestrictionsResponseSchema)` to create a new message.
 */
export const RestrictionsResponseSchema: GenMessage<RestrictionsResponse, {jsonType: RestrictionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 9);

/**
 * @generated from message guardianai.v1.user.UserRestriction
 */
export type UserRestriction = Message<"guardianai.v1.user.UserRestriction"> & {
  /**
   * @generated from field: string restriction_type = 1;
   */
  restrictionType: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: int64 applied_at = 3;
   */
  appliedAt: bigint;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.user.UserRestriction
 */
export type UserRestrictionJson = {
  /**
   * @generated from field: string restriction_type = 1;
   */
  restrictionType?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: int64 applied_at = 3;
   */
  appliedAt?: string;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.user.UserRestriction.
 * Use `create(UserRestrictionSchema)` to create a new message.
 */
export const UserRestrictionSchema: GenMessage<UserRestriction, {jsonType: UserRestrictionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 10);

/**
 * @generated from message guardianai.v1.user.UserStatusResponse
 */
export type UserStatusResponse = Message<"guardianai.v1.user.UserStatusResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int64 last_active = 3;
   */
  lastActive: bigint;
};

/**
 * @generated from message guardianai.v1.user.UserStatusResponse
 */
export type UserStatusResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int64 last_active = 3;
   */
  lastActive?: string;
};

/**
 * Describes the message guardianai.v1.user.UserStatusResponse.
 * Use `create(UserStatusResponseSchema)` to create a new message.
 */
export const UserStatusResponseSchema: GenMessage<UserStatusResponse, {jsonType: UserStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 11);

/**
 * @generated from message guardianai.v1.user.UpdateUserStatusRequest
 */
export type UpdateUserStatusRequest = Message<"guardianai.v1.user.UpdateUserStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.user.UpdateUserStatusRequest
 */
export type UpdateUserStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.user.UpdateUserStatusRequest.
 * Use `create(UpdateUserStatusRequestSchema)` to create a new message.
 */
export const UpdateUserStatusRequestSchema: GenMessage<UpdateUserStatusRequest, {jsonType: UpdateUserStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 12);

/**
 * @generated from message guardianai.v1.user.UpdateCertificationRequest
 */
export type UpdateCertificationRequest = Message<"guardianai.v1.user.UpdateCertificationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: guardianai.v1.user.Certification certification = 2;
   */
  certification?: Certification;
};

/**
 * @generated from message guardianai.v1.user.UpdateCertificationRequest
 */
export type UpdateCertificationRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: guardianai.v1.user.Certification certification = 2;
   */
  certification?: CertificationJson;
};

/**
 * Describes the message guardianai.v1.user.UpdateCertificationRequest.
 * Use `create(UpdateCertificationRequestSchema)` to create a new message.
 */
export const UpdateCertificationRequestSchema: GenMessage<UpdateCertificationRequest, {jsonType: UpdateCertificationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 13);

/**
 * @generated from message guardianai.v1.user.UpdateCertificationResponse
 */
export type UpdateCertificationResponse = Message<"guardianai.v1.user.UpdateCertificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.user.Certification certification = 3;
   */
  certification?: Certification;
};

/**
 * @generated from message guardianai.v1.user.UpdateCertificationResponse
 */
export type UpdateCertificationResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.user.Certification certification = 3;
   */
  certification?: CertificationJson;
};

/**
 * Describes the message guardianai.v1.user.UpdateCertificationResponse.
 * Use `create(UpdateCertificationResponseSchema)` to create a new message.
 */
export const UpdateCertificationResponseSchema: GenMessage<UpdateCertificationResponse, {jsonType: UpdateCertificationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 14);

/**
 * @generated from message guardianai.v1.user.GetCertificationRequirementsRequest
 */
export type GetCertificationRequirementsRequest = Message<"guardianai.v1.user.GetCertificationRequirementsRequest"> & {
  /**
   * @generated from field: string country = 1;
   */
  country: string;

  /**
   * @generated from field: string state_province = 2;
   */
  stateProvince: string;

  /**
   * INVESTIGATOR or EVIDENCE_SCOUT
   *
   * @generated from field: string role = 3;
   */
  role: string;
};

/**
 * @generated from message guardianai.v1.user.GetCertificationRequirementsRequest
 */
export type GetCertificationRequirementsRequestJson = {
  /**
   * @generated from field: string country = 1;
   */
  country?: string;

  /**
   * @generated from field: string state_province = 2;
   */
  stateProvince?: string;

  /**
   * INVESTIGATOR or EVIDENCE_SCOUT
   *
   * @generated from field: string role = 3;
   */
  role?: string;
};

/**
 * Describes the message guardianai.v1.user.GetCertificationRequirementsRequest.
 * Use `create(GetCertificationRequirementsRequestSchema)` to create a new message.
 */
export const GetCertificationRequirementsRequestSchema: GenMessage<GetCertificationRequirementsRequest, {jsonType: GetCertificationRequirementsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 15);

/**
 * @generated from message guardianai.v1.user.CertificationRequirement
 */
export type CertificationRequirement = Message<"guardianai.v1.user.CertificationRequirement"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool is_mandatory = 4;
   */
  isMandatory: boolean;

  /**
   * @generated from field: string issuing_authority = 5;
   */
  issuingAuthority: string;

  /**
   * @generated from field: string website_url = 6;
   */
  websiteUrl: string;

  /**
   * @generated from field: repeated string alternative_certifications = 7;
   */
  alternativeCertifications: string[];

  /**
   * @generated from field: int32 validity_period_months = 8;
   */
  validityPeriodMonths: number;

  /**
   * @generated from field: string applicable_region = 9;
   */
  applicableRegion: string;
};

/**
 * @generated from message guardianai.v1.user.CertificationRequirement
 */
export type CertificationRequirementJson = {
  /**
   * @generated from field: string type = 1;
   */
  type?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool is_mandatory = 4;
   */
  isMandatory?: boolean;

  /**
   * @generated from field: string issuing_authority = 5;
   */
  issuingAuthority?: string;

  /**
   * @generated from field: string website_url = 6;
   */
  websiteUrl?: string;

  /**
   * @generated from field: repeated string alternative_certifications = 7;
   */
  alternativeCertifications?: string[];

  /**
   * @generated from field: int32 validity_period_months = 8;
   */
  validityPeriodMonths?: number;

  /**
   * @generated from field: string applicable_region = 9;
   */
  applicableRegion?: string;
};

/**
 * Describes the message guardianai.v1.user.CertificationRequirement.
 * Use `create(CertificationRequirementSchema)` to create a new message.
 */
export const CertificationRequirementSchema: GenMessage<CertificationRequirement, {jsonType: CertificationRequirementJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 16);

/**
 * @generated from message guardianai.v1.user.CertificationRequirementsResponse
 */
export type CertificationRequirementsResponse = Message<"guardianai.v1.user.CertificationRequirementsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.CertificationRequirement requirements = 1;
   */
  requirements: CertificationRequirement[];

  /**
   * @generated from field: bool certifications_required = 2;
   */
  certificationsRequired: boolean;

  /**
   * @generated from field: string region_name = 3;
   */
  regionName: string;

  /**
   * @generated from field: string regulatory_body = 4;
   */
  regulatoryBody: string;

  /**
   * @generated from field: string additional_info = 5;
   */
  additionalInfo: string;

  /**
   * @generated from field: repeated string no_certification_regions = 6;
   */
  noCertificationRegions: string[];
};

/**
 * @generated from message guardianai.v1.user.CertificationRequirementsResponse
 */
export type CertificationRequirementsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.CertificationRequirement requirements = 1;
   */
  requirements?: CertificationRequirementJson[];

  /**
   * @generated from field: bool certifications_required = 2;
   */
  certificationsRequired?: boolean;

  /**
   * @generated from field: string region_name = 3;
   */
  regionName?: string;

  /**
   * @generated from field: string regulatory_body = 4;
   */
  regulatoryBody?: string;

  /**
   * @generated from field: string additional_info = 5;
   */
  additionalInfo?: string;

  /**
   * @generated from field: repeated string no_certification_regions = 6;
   */
  noCertificationRegions?: string[];
};

/**
 * Describes the message guardianai.v1.user.CertificationRequirementsResponse.
 * Use `create(CertificationRequirementsResponseSchema)` to create a new message.
 */
export const CertificationRequirementsResponseSchema: GenMessage<CertificationRequirementsResponse, {jsonType: CertificationRequirementsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 17);

/**
 * @generated from message guardianai.v1.user.CheckMarketplaceEligibilityRequest
 */
export type CheckMarketplaceEligibilityRequest = Message<"guardianai.v1.user.CheckMarketplaceEligibilityRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string opportunity_country = 2;
   */
  opportunityCountry: string;

  /**
   * @generated from field: string opportunity_state_province = 3;
   */
  opportunityStateProvince: string;
};

/**
 * @generated from message guardianai.v1.user.CheckMarketplaceEligibilityRequest
 */
export type CheckMarketplaceEligibilityRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string opportunity_country = 2;
   */
  opportunityCountry?: string;

  /**
   * @generated from field: string opportunity_state_province = 3;
   */
  opportunityStateProvince?: string;
};

/**
 * Describes the message guardianai.v1.user.CheckMarketplaceEligibilityRequest.
 * Use `create(CheckMarketplaceEligibilityRequestSchema)` to create a new message.
 */
export const CheckMarketplaceEligibilityRequestSchema: GenMessage<CheckMarketplaceEligibilityRequest, {jsonType: CheckMarketplaceEligibilityRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 18);

/**
 * @generated from message guardianai.v1.user.CheckMarketplaceEligibilityResponse
 */
export type CheckMarketplaceEligibilityResponse = Message<"guardianai.v1.user.CheckMarketplaceEligibilityResponse"> & {
  /**
   * @generated from field: bool can_bid = 1;
   */
  canBid: boolean;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: repeated string missing_certifications = 3;
   */
  missingCertifications: string[];

  /**
   * @generated from field: repeated string alternative_regions = 4;
   */
  alternativeRegions: string[];
};

/**
 * @generated from message guardianai.v1.user.CheckMarketplaceEligibilityResponse
 */
export type CheckMarketplaceEligibilityResponseJson = {
  /**
   * @generated from field: bool can_bid = 1;
   */
  canBid?: boolean;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: repeated string missing_certifications = 3;
   */
  missingCertifications?: string[];

  /**
   * @generated from field: repeated string alternative_regions = 4;
   */
  alternativeRegions?: string[];
};

/**
 * Describes the message guardianai.v1.user.CheckMarketplaceEligibilityResponse.
 * Use `create(CheckMarketplaceEligibilityResponseSchema)` to create a new message.
 */
export const CheckMarketplaceEligibilityResponseSchema: GenMessage<CheckMarketplaceEligibilityResponse, {jsonType: CheckMarketplaceEligibilityResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 19);

/**
 * @generated from message guardianai.v1.user.AIAgentProfile
 */
export type AIAgentProfile = Message<"guardianai.v1.user.AIAgentProfile"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * AI_AGENT_EVIDENCE_SCOUT, AI_AGENT_INVESTIGATOR
   *
   * @generated from field: string agent_type = 3;
   */
  agentType: string;

  /**
   * @generated from field: string developer_id = 4;
   */
  developerId: string;

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion: string;

  /**
   * @generated from field: repeated string capabilities = 6;
   */
  capabilities: string[];

  /**
   * @generated from field: guardianai.v1.user.AIAgentMetrics metrics = 7;
   */
  metrics?: AIAgentMetrics;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration configuration = 8;
   */
  configuration?: AIAgentConfiguration;

  /**
   * @generated from field: string api_endpoint = 9;
   */
  apiEndpoint: string;

  /**
   * GRPC, REST, WebSocket
   *
   * @generated from field: repeated string supported_protocols = 10;
   */
  supportedProtocols: string[];

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt: string;

  /**
   * ACTIVE, INACTIVE, SUSPENDED, MAINTENANCE
   *
   * @generated from field: string status = 13;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.user.AIAgentProfile
 */
export type AIAgentProfileJson = {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * AI_AGENT_EVIDENCE_SCOUT, AI_AGENT_INVESTIGATOR
   *
   * @generated from field: string agent_type = 3;
   */
  agentType?: string;

  /**
   * @generated from field: string developer_id = 4;
   */
  developerId?: string;

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion?: string;

  /**
   * @generated from field: repeated string capabilities = 6;
   */
  capabilities?: string[];

  /**
   * @generated from field: guardianai.v1.user.AIAgentMetrics metrics = 7;
   */
  metrics?: AIAgentMetricsJson;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration configuration = 8;
   */
  configuration?: AIAgentConfigurationJson;

  /**
   * @generated from field: string api_endpoint = 9;
   */
  apiEndpoint?: string;

  /**
   * GRPC, REST, WebSocket
   *
   * @generated from field: repeated string supported_protocols = 10;
   */
  supportedProtocols?: string[];

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt?: string;

  /**
   * ACTIVE, INACTIVE, SUSPENDED, MAINTENANCE
   *
   * @generated from field: string status = 13;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.user.AIAgentProfile.
 * Use `create(AIAgentProfileSchema)` to create a new message.
 */
export const AIAgentProfileSchema: GenMessage<AIAgentProfile, {jsonType: AIAgentProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 20);

/**
 * @generated from message guardianai.v1.user.AIAgentMetrics
 */
export type AIAgentMetrics = Message<"guardianai.v1.user.AIAgentMetrics"> & {
  /**
   * @generated from field: double success_rate = 1;
   */
  successRate: number;

  /**
   * @generated from field: int32 total_tasks_completed = 2;
   */
  totalTasksCompleted: number;

  /**
   * @generated from field: int32 total_tasks_failed = 3;
   */
  totalTasksFailed: number;

  /**
   * @generated from field: double avg_response_time_ms = 4;
   */
  avgResponseTimeMs: number;

  /**
   * @generated from field: double avg_accuracy_score = 5;
   */
  avgAccuracyScore: number;

  /**
   * @generated from field: repeated string specializations = 6;
   */
  specializations: string[];

  /**
   * @generated from field: int32 concurrent_capacity = 7;
   */
  concurrentCapacity: number;

  /**
   * @generated from field: string last_health_check = 8;
   */
  lastHealthCheck: string;

  /**
   * @generated from field: repeated guardianai.v1.user.AIAgentPerformanceMetric daily_metrics = 9;
   */
  dailyMetrics: AIAgentPerformanceMetric[];
};

/**
 * @generated from message guardianai.v1.user.AIAgentMetrics
 */
export type AIAgentMetricsJson = {
  /**
   * @generated from field: double success_rate = 1;
   */
  successRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 total_tasks_completed = 2;
   */
  totalTasksCompleted?: number;

  /**
   * @generated from field: int32 total_tasks_failed = 3;
   */
  totalTasksFailed?: number;

  /**
   * @generated from field: double avg_response_time_ms = 4;
   */
  avgResponseTimeMs?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double avg_accuracy_score = 5;
   */
  avgAccuracyScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated string specializations = 6;
   */
  specializations?: string[];

  /**
   * @generated from field: int32 concurrent_capacity = 7;
   */
  concurrentCapacity?: number;

  /**
   * @generated from field: string last_health_check = 8;
   */
  lastHealthCheck?: string;

  /**
   * @generated from field: repeated guardianai.v1.user.AIAgentPerformanceMetric daily_metrics = 9;
   */
  dailyMetrics?: AIAgentPerformanceMetricJson[];
};

/**
 * Describes the message guardianai.v1.user.AIAgentMetrics.
 * Use `create(AIAgentMetricsSchema)` to create a new message.
 */
export const AIAgentMetricsSchema: GenMessage<AIAgentMetrics, {jsonType: AIAgentMetricsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 21);

/**
 * @generated from message guardianai.v1.user.AIAgentPerformanceMetric
 */
export type AIAgentPerformanceMetric = Message<"guardianai.v1.user.AIAgentPerformanceMetric"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: int32 tasks_completed = 2;
   */
  tasksCompleted: number;

  /**
   * @generated from field: double success_rate = 3;
   */
  successRate: number;

  /**
   * @generated from field: double avg_response_time_ms = 4;
   */
  avgResponseTimeMs: number;

  /**
   * @generated from field: double accuracy_score = 5;
   */
  accuracyScore: number;
};

/**
 * @generated from message guardianai.v1.user.AIAgentPerformanceMetric
 */
export type AIAgentPerformanceMetricJson = {
  /**
   * @generated from field: string date = 1;
   */
  date?: string;

  /**
   * @generated from field: int32 tasks_completed = 2;
   */
  tasksCompleted?: number;

  /**
   * @generated from field: double success_rate = 3;
   */
  successRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double avg_response_time_ms = 4;
   */
  avgResponseTimeMs?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double accuracy_score = 5;
   */
  accuracyScore?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.user.AIAgentPerformanceMetric.
 * Use `create(AIAgentPerformanceMetricSchema)` to create a new message.
 */
export const AIAgentPerformanceMetricSchema: GenMessage<AIAgentPerformanceMetric, {jsonType: AIAgentPerformanceMetricJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 22);

/**
 * @generated from message guardianai.v1.user.AIAgentConfiguration
 */
export type AIAgentConfiguration = Message<"guardianai.v1.user.AIAgentConfiguration"> & {
  /**
   * @generated from field: repeated string enabled_features = 1;
   */
  enabledFeatures: string[];

  /**
   * @generated from field: int32 max_concurrent_tasks = 2;
   */
  maxConcurrentTasks: number;

  /**
   * @generated from field: int32 timeout_seconds = 3;
   */
  timeoutSeconds: number;

  /**
   * @generated from field: repeated string fraud_categories = 4;
   */
  fraudCategories: string[];

  /**
   * @generated from field: bool auto_accept_tasks = 5;
   */
  autoAcceptTasks: boolean;

  /**
   * @generated from field: double confidence_threshold = 6;
   */
  confidenceThreshold: number;

  /**
   * @generated from field: repeated string notification_endpoints = 7;
   */
  notificationEndpoints: string[];

  /**
   * JSON configuration
   *
   * @generated from field: string escalation_rules = 8;
   */
  escalationRules: string;
};

/**
 * @generated from message guardianai.v1.user.AIAgentConfiguration
 */
export type AIAgentConfigurationJson = {
  /**
   * @generated from field: repeated string enabled_features = 1;
   */
  enabledFeatures?: string[];

  /**
   * @generated from field: int32 max_concurrent_tasks = 2;
   */
  maxConcurrentTasks?: number;

  /**
   * @generated from field: int32 timeout_seconds = 3;
   */
  timeoutSeconds?: number;

  /**
   * @generated from field: repeated string fraud_categories = 4;
   */
  fraudCategories?: string[];

  /**
   * @generated from field: bool auto_accept_tasks = 5;
   */
  autoAcceptTasks?: boolean;

  /**
   * @generated from field: double confidence_threshold = 6;
   */
  confidenceThreshold?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated string notification_endpoints = 7;
   */
  notificationEndpoints?: string[];

  /**
   * JSON configuration
   *
   * @generated from field: string escalation_rules = 8;
   */
  escalationRules?: string;
};

/**
 * Describes the message guardianai.v1.user.AIAgentConfiguration.
 * Use `create(AIAgentConfigurationSchema)` to create a new message.
 */
export const AIAgentConfigurationSchema: GenMessage<AIAgentConfiguration, {jsonType: AIAgentConfigurationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 23);

/**
 * @generated from message guardianai.v1.user.AIAgentRegistrationRequest
 */
export type AIAgentRegistrationRequest = Message<"guardianai.v1.user.AIAgentRegistrationRequest"> & {
  /**
   * @generated from field: string developer_id = 1;
   */
  developerId: string;

  /**
   * @generated from field: string agent_type = 2;
   */
  agentType: string;

  /**
   * @generated from field: string agent_name = 3;
   */
  agentName: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion: string;

  /**
   * @generated from field: repeated string capabilities = 6;
   */
  capabilities: string[];

  /**
   * @generated from field: string api_endpoint = 7;
   */
  apiEndpoint: string;

  /**
   * @generated from field: repeated string supported_protocols = 8;
   */
  supportedProtocols: string[];

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration initial_configuration = 9;
   */
  initialConfiguration?: AIAgentConfiguration;

  /**
   * @generated from field: string webhook_url = 10;
   */
  webhookUrl: string;
};

/**
 * @generated from message guardianai.v1.user.AIAgentRegistrationRequest
 */
export type AIAgentRegistrationRequestJson = {
  /**
   * @generated from field: string developer_id = 1;
   */
  developerId?: string;

  /**
   * @generated from field: string agent_type = 2;
   */
  agentType?: string;

  /**
   * @generated from field: string agent_name = 3;
   */
  agentName?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: string model_version = 5;
   */
  modelVersion?: string;

  /**
   * @generated from field: repeated string capabilities = 6;
   */
  capabilities?: string[];

  /**
   * @generated from field: string api_endpoint = 7;
   */
  apiEndpoint?: string;

  /**
   * @generated from field: repeated string supported_protocols = 8;
   */
  supportedProtocols?: string[];

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration initial_configuration = 9;
   */
  initialConfiguration?: AIAgentConfigurationJson;

  /**
   * @generated from field: string webhook_url = 10;
   */
  webhookUrl?: string;
};

/**
 * Describes the message guardianai.v1.user.AIAgentRegistrationRequest.
 * Use `create(AIAgentRegistrationRequestSchema)` to create a new message.
 */
export const AIAgentRegistrationRequestSchema: GenMessage<AIAgentRegistrationRequest, {jsonType: AIAgentRegistrationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 24);

/**
 * @generated from message guardianai.v1.user.AIAgentRegistrationResponse
 */
export type AIAgentRegistrationResponse = Message<"guardianai.v1.user.AIAgentRegistrationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string agent_id = 3;
   */
  agentId: string;

  /**
   * @generated from field: string api_key = 4;
   */
  apiKey: string;
};

/**
 * @generated from message guardianai.v1.user.AIAgentRegistrationResponse
 */
export type AIAgentRegistrationResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string agent_id = 3;
   */
  agentId?: string;

  /**
   * @generated from field: string api_key = 4;
   */
  apiKey?: string;
};

/**
 * Describes the message guardianai.v1.user.AIAgentRegistrationResponse.
 * Use `create(AIAgentRegistrationResponseSchema)` to create a new message.
 */
export const AIAgentRegistrationResponseSchema: GenMessage<AIAgentRegistrationResponse, {jsonType: AIAgentRegistrationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 25);

/**
 * @generated from message guardianai.v1.user.UpdateAIAgentConfigurationRequest
 */
export type UpdateAIAgentConfigurationRequest = Message<"guardianai.v1.user.UpdateAIAgentConfigurationRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration configuration = 2;
   */
  configuration?: AIAgentConfiguration;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;
};

/**
 * @generated from message guardianai.v1.user.UpdateAIAgentConfigurationRequest
 */
export type UpdateAIAgentConfigurationRequestJson = {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId?: string;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration configuration = 2;
   */
  configuration?: AIAgentConfigurationJson;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message guardianai.v1.user.UpdateAIAgentConfigurationRequest.
 * Use `create(UpdateAIAgentConfigurationRequestSchema)` to create a new message.
 */
export const UpdateAIAgentConfigurationRequestSchema: GenMessage<UpdateAIAgentConfigurationRequest, {jsonType: UpdateAIAgentConfigurationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 26);

/**
 * @generated from message guardianai.v1.user.UpdateAIAgentConfigurationResponse
 */
export type UpdateAIAgentConfigurationResponse = Message<"guardianai.v1.user.UpdateAIAgentConfigurationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration updated_configuration = 3;
   */
  updatedConfiguration?: AIAgentConfiguration;
};

/**
 * @generated from message guardianai.v1.user.UpdateAIAgentConfigurationResponse
 */
export type UpdateAIAgentConfigurationResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.user.AIAgentConfiguration updated_configuration = 3;
   */
  updatedConfiguration?: AIAgentConfigurationJson;
};

/**
 * Describes the message guardianai.v1.user.UpdateAIAgentConfigurationResponse.
 * Use `create(UpdateAIAgentConfigurationResponseSchema)` to create a new message.
 */
export const UpdateAIAgentConfigurationResponseSchema: GenMessage<UpdateAIAgentConfigurationResponse, {jsonType: UpdateAIAgentConfigurationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 27);

/**
 * @generated from message guardianai.v1.user.GetAIAgentMetricsRequest
 */
export type GetAIAgentMetricsRequest = Message<"guardianai.v1.user.GetAIAgentMetricsRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: string date_from = 2;
   */
  dateFrom: string;

  /**
   * @generated from field: string date_to = 3;
   */
  dateTo: string;

  /**
   * daily, hourly, real_time
   *
   * @generated from field: string metric_type = 4;
   */
  metricType: string;
};

/**
 * @generated from message guardianai.v1.user.GetAIAgentMetricsRequest
 */
export type GetAIAgentMetricsRequestJson = {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId?: string;

  /**
   * @generated from field: string date_from = 2;
   */
  dateFrom?: string;

  /**
   * @generated from field: string date_to = 3;
   */
  dateTo?: string;

  /**
   * daily, hourly, real_time
   *
   * @generated from field: string metric_type = 4;
   */
  metricType?: string;
};

/**
 * Describes the message guardianai.v1.user.GetAIAgentMetricsRequest.
 * Use `create(GetAIAgentMetricsRequestSchema)` to create a new message.
 */
export const GetAIAgentMetricsRequestSchema: GenMessage<GetAIAgentMetricsRequest, {jsonType: GetAIAgentMetricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 28);

/**
 * @generated from message guardianai.v1.user.ListDeveloperAgentsRequest
 */
export type ListDeveloperAgentsRequest = Message<"guardianai.v1.user.ListDeveloperAgentsRequest"> & {
  /**
   * @generated from field: string developer_id = 1;
   */
  developerId: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.user.ListDeveloperAgentsRequest
 */
export type ListDeveloperAgentsRequestJson = {
  /**
   * @generated from field: string developer_id = 1;
   */
  developerId?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.user.ListDeveloperAgentsRequest.
 * Use `create(ListDeveloperAgentsRequestSchema)` to create a new message.
 */
export const ListDeveloperAgentsRequestSchema: GenMessage<ListDeveloperAgentsRequest, {jsonType: ListDeveloperAgentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 29);

/**
 * @generated from message guardianai.v1.user.ListDeveloperAgentsResponse
 */
export type ListDeveloperAgentsResponse = Message<"guardianai.v1.user.ListDeveloperAgentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.AIAgentProfile agents = 1;
   */
  agents: AIAgentProfile[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.user.ListDeveloperAgentsResponse
 */
export type ListDeveloperAgentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.AIAgentProfile agents = 1;
   */
  agents?: AIAgentProfileJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.user.ListDeveloperAgentsResponse.
 * Use `create(ListDeveloperAgentsResponseSchema)` to create a new message.
 */
export const ListDeveloperAgentsResponseSchema: GenMessage<ListDeveloperAgentsResponse, {jsonType: ListDeveloperAgentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 30);

/**
 * @generated from message guardianai.v1.user.PlanResponse
 */
export type PlanResponse = Message<"guardianai.v1.user.PlanResponse"> & {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string tier = 3;
   */
  tier: string;

  /**
   * @generated from field: int64 price_cents = 4;
   */
  priceCents: bigint;

  /**
   * @generated from field: int64 credits_per_month = 5;
   */
  creditsPerMonth: bigint;

  /**
   * @generated from field: repeated string features = 6;
   */
  features: string[];

  /**
   * @generated from field: int64 current_period_end = 7;
   */
  currentPeriodEnd: bigint;
};

/**
 * @generated from message guardianai.v1.user.PlanResponse
 */
export type PlanResponseJson = {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string tier = 3;
   */
  tier?: string;

  /**
   * @generated from field: int64 price_cents = 4;
   */
  priceCents?: string;

  /**
   * @generated from field: int64 credits_per_month = 5;
   */
  creditsPerMonth?: string;

  /**
   * @generated from field: repeated string features = 6;
   */
  features?: string[];

  /**
   * @generated from field: int64 current_period_end = 7;
   */
  currentPeriodEnd?: string;
};

/**
 * Describes the message guardianai.v1.user.PlanResponse.
 * Use `create(PlanResponseSchema)` to create a new message.
 */
export const PlanResponseSchema: GenMessage<PlanResponse, {jsonType: PlanResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 31);

/**
 * @generated from message guardianai.v1.user.GetAvailablePlansRequest
 */
export type GetAvailablePlansRequest = Message<"guardianai.v1.user.GetAvailablePlansRequest"> & {
};

/**
 * @generated from message guardianai.v1.user.GetAvailablePlansRequest
 */
export type GetAvailablePlansRequestJson = {
};

/**
 * Describes the message guardianai.v1.user.GetAvailablePlansRequest.
 * Use `create(GetAvailablePlansRequestSchema)` to create a new message.
 */
export const GetAvailablePlansRequestSchema: GenMessage<GetAvailablePlansRequest, {jsonType: GetAvailablePlansRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 32);

/**
 * @generated from message guardianai.v1.user.AvailablePlansResponse
 */
export type AvailablePlansResponse = Message<"guardianai.v1.user.AvailablePlansResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.PlanResponse plans = 1;
   */
  plans: PlanResponse[];
};

/**
 * @generated from message guardianai.v1.user.AvailablePlansResponse
 */
export type AvailablePlansResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.PlanResponse plans = 1;
   */
  plans?: PlanResponseJson[];
};

/**
 * Describes the message guardianai.v1.user.AvailablePlansResponse.
 * Use `create(AvailablePlansResponseSchema)` to create a new message.
 */
export const AvailablePlansResponseSchema: GenMessage<AvailablePlansResponse, {jsonType: AvailablePlansResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 33);

/**
 * @generated from message guardianai.v1.user.UpgradePlanRequest
 */
export type UpgradePlanRequest = Message<"guardianai.v1.user.UpgradePlanRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string new_plan_id = 2;
   */
  newPlanId: string;
};

/**
 * @generated from message guardianai.v1.user.UpgradePlanRequest
 */
export type UpgradePlanRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string new_plan_id = 2;
   */
  newPlanId?: string;
};

/**
 * Describes the message guardianai.v1.user.UpgradePlanRequest.
 * Use `create(UpgradePlanRequestSchema)` to create a new message.
 */
export const UpgradePlanRequestSchema: GenMessage<UpgradePlanRequest, {jsonType: UpgradePlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 34);

/**
 * @generated from message guardianai.v1.user.DowngradePlanRequest
 */
export type DowngradePlanRequest = Message<"guardianai.v1.user.DowngradePlanRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string new_plan_id = 2;
   */
  newPlanId: string;
};

/**
 * @generated from message guardianai.v1.user.DowngradePlanRequest
 */
export type DowngradePlanRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string new_plan_id = 2;
   */
  newPlanId?: string;
};

/**
 * Describes the message guardianai.v1.user.DowngradePlanRequest.
 * Use `create(DowngradePlanRequestSchema)` to create a new message.
 */
export const DowngradePlanRequestSchema: GenMessage<DowngradePlanRequest, {jsonType: DowngradePlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 35);

/**
 * @generated from message guardianai.v1.user.CancelSubRequest
 */
export type CancelSubRequest = Message<"guardianai.v1.user.CancelSubRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.user.CancelSubRequest
 */
export type CancelSubRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.user.CancelSubRequest.
 * Use `create(CancelSubRequestSchema)` to create a new message.
 */
export const CancelSubRequestSchema: GenMessage<CancelSubRequest, {jsonType: CancelSubRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 36);

/**
 * @generated from message guardianai.v1.user.CancelSubResponse
 */
export type CancelSubResponse = Message<"guardianai.v1.user.CancelSubResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int64 effective_date = 2;
   */
  effectiveDate: bigint;
};

/**
 * @generated from message guardianai.v1.user.CancelSubResponse
 */
export type CancelSubResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int64 effective_date = 2;
   */
  effectiveDate?: string;
};

/**
 * Describes the message guardianai.v1.user.CancelSubResponse.
 * Use `create(CancelSubResponseSchema)` to create a new message.
 */
export const CancelSubResponseSchema: GenMessage<CancelSubResponse, {jsonType: CancelSubResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 37);

/**
 * @generated from message guardianai.v1.user.UsageResponse
 */
export type UsageResponse = Message<"guardianai.v1.user.UsageResponse"> & {
  /**
   * @generated from field: int64 credits_used = 1;
   */
  creditsUsed: bigint;

  /**
   * @generated from field: int64 credits_remaining = 2;
   */
  creditsRemaining: bigint;

  /**
   * @generated from field: int64 api_calls = 3;
   */
  apiCalls: bigint;

  /**
   * @generated from field: int64 reports_submitted = 4;
   */
  reportsSubmitted: bigint;

  /**
   * @generated from field: int64 period_start = 5;
   */
  periodStart: bigint;

  /**
   * @generated from field: int64 period_end = 6;
   */
  periodEnd: bigint;
};

/**
 * @generated from message guardianai.v1.user.UsageResponse
 */
export type UsageResponseJson = {
  /**
   * @generated from field: int64 credits_used = 1;
   */
  creditsUsed?: string;

  /**
   * @generated from field: int64 credits_remaining = 2;
   */
  creditsRemaining?: string;

  /**
   * @generated from field: int64 api_calls = 3;
   */
  apiCalls?: string;

  /**
   * @generated from field: int64 reports_submitted = 4;
   */
  reportsSubmitted?: string;

  /**
   * @generated from field: int64 period_start = 5;
   */
  periodStart?: string;

  /**
   * @generated from field: int64 period_end = 6;
   */
  periodEnd?: string;
};

/**
 * Describes the message guardianai.v1.user.UsageResponse.
 * Use `create(UsageResponseSchema)` to create a new message.
 */
export const UsageResponseSchema: GenMessage<UsageResponse, {jsonType: UsageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 38);

/**
 * @generated from message guardianai.v1.user.GetBillingHistoryRequest
 */
export type GetBillingHistoryRequest = Message<"guardianai.v1.user.GetBillingHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.user.GetBillingHistoryRequest
 */
export type GetBillingHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.user.GetBillingHistoryRequest.
 * Use `create(GetBillingHistoryRequestSchema)` to create a new message.
 */
export const GetBillingHistoryRequestSchema: GenMessage<GetBillingHistoryRequest, {jsonType: GetBillingHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 39);

/**
 * @generated from message guardianai.v1.user.BillingHistoryResponse
 */
export type BillingHistoryResponse = Message<"guardianai.v1.user.BillingHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.user.BillingRecord records = 1;
   */
  records: BillingRecord[];
};

/**
 * @generated from message guardianai.v1.user.BillingHistoryResponse
 */
export type BillingHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.user.BillingRecord records = 1;
   */
  records?: BillingRecordJson[];
};

/**
 * Describes the message guardianai.v1.user.BillingHistoryResponse.
 * Use `create(BillingHistoryResponseSchema)` to create a new message.
 */
export const BillingHistoryResponseSchema: GenMessage<BillingHistoryResponse, {jsonType: BillingHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 40);

/**
 * @generated from message guardianai.v1.user.BillingRecord
 */
export type BillingRecord = Message<"guardianai.v1.user.BillingRecord"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 billing_date = 4;
   */
  billingDate: bigint;
};

/**
 * @generated from message guardianai.v1.user.BillingRecord
 */
export type BillingRecordJson = {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int64 billing_date = 4;
   */
  billingDate?: string;
};

/**
 * Describes the message guardianai.v1.user.BillingRecord.
 * Use `create(BillingRecordSchema)` to create a new message.
 */
export const BillingRecordSchema: GenMessage<BillingRecord, {jsonType: BillingRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 41);

/**
 * @generated from message guardianai.v1.user.UpdateBillingRequest
 */
export type UpdateBillingRequest = Message<"guardianai.v1.user.UpdateBillingRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId: string;

  /**
   * @generated from field: string billing_email = 3;
   */
  billingEmail: string;
};

/**
 * @generated from message guardianai.v1.user.UpdateBillingRequest
 */
export type UpdateBillingRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string payment_method_id = 2;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: string billing_email = 3;
   */
  billingEmail?: string;
};

/**
 * Describes the message guardianai.v1.user.UpdateBillingRequest.
 * Use `create(UpdateBillingRequestSchema)` to create a new message.
 */
export const UpdateBillingRequestSchema: GenMessage<UpdateBillingRequest, {jsonType: UpdateBillingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 42);

/**
 * @generated from message guardianai.v1.user.BillingInfoResponse
 */
export type BillingInfoResponse = Message<"guardianai.v1.user.BillingInfoResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.user.BillingInfoResponse
 */
export type BillingInfoResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.user.BillingInfoResponse.
 * Use `create(BillingInfoResponseSchema)` to create a new message.
 */
export const BillingInfoResponseSchema: GenMessage<BillingInfoResponse, {jsonType: BillingInfoResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_user_user, 43);

/**
 * @generated from service guardianai.v1.user.UserService
 */
export const UserService: GenService<{
  /**
   * Profile management
   *
   * @generated from rpc guardianai.v1.user.UserService.GetUserProfile
   */
  getUserProfile: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof UserProfileSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.UpdateUserProfile
   */
  updateUserProfile: {
    methodKind: "unary";
    input: typeof UpdateUserProfileRequestSchema;
    output: typeof UserProfileSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof UserListSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.SetUserRestriction
   */
  setUserRestriction: {
    methodKind: "unary";
    input: typeof UserRestrictionRequestSchema;
    output: typeof UserRestrictionResponseSchema;
  },
  /**
   * User status (from backend)
   *
   * @generated from rpc guardianai.v1.user.UserService.GetRestrictions
   */
  getRestrictions: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof RestrictionsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.GetStatus
   */
  getStatus: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof UserStatusResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.UpdateStatus
   */
  updateStatus: {
    methodKind: "unary";
    input: typeof UpdateUserStatusRequestSchema;
    output: typeof UserStatusResponseSchema;
  },
  /**
   * Certification management
   *
   * @generated from rpc guardianai.v1.user.UserService.UpdateCertification
   */
  updateCertification: {
    methodKind: "unary";
    input: typeof UpdateCertificationRequestSchema;
    output: typeof UpdateCertificationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.GetCertificationRequirements
   */
  getCertificationRequirements: {
    methodKind: "unary";
    input: typeof GetCertificationRequirementsRequestSchema;
    output: typeof CertificationRequirementsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.CheckMarketplaceEligibility
   */
  checkMarketplaceEligibility: {
    methodKind: "unary";
    input: typeof CheckMarketplaceEligibilityRequestSchema;
    output: typeof CheckMarketplaceEligibilityResponseSchema;
  },
  /**
   * AI Agent management
   *
   * @generated from rpc guardianai.v1.user.UserService.RegisterAIAgent
   */
  registerAIAgent: {
    methodKind: "unary";
    input: typeof AIAgentRegistrationRequestSchema;
    output: typeof AIAgentRegistrationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.GetAIAgentProfile
   */
  getAIAgentProfile: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof AIAgentProfileSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.UpdateAIAgentConfiguration
   */
  updateAIAgentConfiguration: {
    methodKind: "unary";
    input: typeof UpdateAIAgentConfigurationRequestSchema;
    output: typeof UpdateAIAgentConfigurationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.GetAIAgentMetrics
   */
  getAIAgentMetrics: {
    methodKind: "unary";
    input: typeof GetAIAgentMetricsRequestSchema;
    output: typeof AIAgentMetricsSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.UserService.ListDeveloperAgents
   */
  listDeveloperAgents: {
    methodKind: "unary";
    input: typeof ListDeveloperAgentsRequestSchema;
    output: typeof ListDeveloperAgentsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_user_user, 0);

/**
 * @generated from service guardianai.v1.user.SubscriptionService
 */
export const SubscriptionService: GenService<{
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.GetCurrentPlan
   */
  getCurrentPlan: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof PlanResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.GetAvailablePlans
   */
  getAvailablePlans: {
    methodKind: "unary";
    input: typeof GetAvailablePlansRequestSchema;
    output: typeof AvailablePlansResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.UpgradePlan
   */
  upgradePlan: {
    methodKind: "unary";
    input: typeof UpgradePlanRequestSchema;
    output: typeof PlanResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.DowngradePlan
   */
  downgradePlan: {
    methodKind: "unary";
    input: typeof DowngradePlanRequestSchema;
    output: typeof PlanResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.CancelSubscription
   */
  cancelSubscription: {
    methodKind: "unary";
    input: typeof CancelSubRequestSchema;
    output: typeof CancelSubResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.GetUsageStats
   */
  getUsageStats: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof UsageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.GetBillingHistory
   */
  getBillingHistory: {
    methodKind: "unary";
    input: typeof GetBillingHistoryRequestSchema;
    output: typeof BillingHistoryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.user.SubscriptionService.UpdateBillingInfo
   */
  updateBillingInfo: {
    methodKind: "unary";
    input: typeof UpdateBillingRequestSchema;
    output: typeof BillingInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_user_user, 1);

